import { useState } from 'react';

import { trpc } from '../../config/trpc';

export const useUpdateRequest = (id?: number) => {
  const { mutateAsync, isLoading, error, failureCount } = trpc.updateRequest.useMutation();

  // When a request is made, failureCount is changed to zero, then changed to 1 if
  // the request fails. This limits it so that it will cause an update only on a change to a different value
  // This is used in resetting the request status back to the current value on error
  const [failureIndicator, setFailureIndicator] = useState(0);
  if (failureIndicator !== failureCount) setFailureIndicator(failureCount);

  const mutate = (args: Parameters<typeof mutateAsync>[0]) => mutateAsync({ id, ...args });

  return {
    mutate,
    isLoading,
    errorMessage: error?.message,
    failureIndicator,
  };
};
